import { IJobCandidateInteraction } from 'wisestep-api';
import {
  getCurrentZoneAbbr,
  getCurrentZoneAbbrInHour,
  getCurrentZoneAbbrInMinute,
} from 'wisestep-base';

export const SubmissionListingDefaultQuery: IJobCandidateInteraction = {
  query: '',
  applicationStage: '',
  searchScope: 'EVERYWHERE',
  submittedByRecruiterIds: [],
  submittedAsTeamMemberEmails: [],
  jobTitle: '',
  jobCandidateMapping: false,
  salaryCurrency: '',
  minSalary: 0,
  maxSalary: 0,
  clientNames: [],

  jobLocations: [],
  searchAcrossTeams: [],
  searchAcrossJobPostingTeams: [],
  tags: [],
  employers: [],
  currentEmployers: [],
  skills: [],
  searchAcross: ['CRM_TEAMS_SHARING'],
  aggregationFields: ['ApplicationStageStatus'],
  noticePeriodMinDays: 0,
  noticePeriodMaxDays: 0,
  includeUniqueCandidatesCount: 'true',
  page: 0,
  size: 20,
  sort: ['createdOn,desc'],
  jobClientRecruiterEmails: [],
  jobAccountManagerEmails: [],
  languages: [],
  sources: [],
  jobTitles: [],

  auditQuery: false,
  datesUnionBy: 'CREATED_OR_UPDATED_BETWEEN',

  queryType: 'none',
  currentStageCurrentStatusPairs: [],
  utcOffset: getCurrentZoneAbbr(),
  utcOffsetInHour: parseInt(getCurrentZoneAbbrInHour()),
  utcOffsetInMinute: parseInt(getCurrentZoneAbbrInMinute()),
};
